<div [formGroup]="form">

    <!-- affichage des délégations -->
    <div *ngIf="displayedDelegationsList | arrayNotEmpty">

        <kal-form-field [kalTheme]="theme">

            <kal-select formControlName="delegationId"
                        label="Délégation"
                        tabindex="1">

                <kal-option *ngFor="let delegation of displayedDelegationsList"
                            [value]="delegation.Id">
                    {{ delegation.CENom }}
                </kal-option>

            </kal-select>

        </kal-form-field>

    </div>

    <!-- affichage des points de vente -->
    <div *ngIf="displayedSellsPointList | arrayNotEmpty">

        <kal-form-field [kalTheme]="theme">

            <kal-select formControlName="sellPointId"
                        label="Point de vente"
                        tabindex="1">

                <kal-option *ngFor="let sellPoint of displayedSellsPointList"
                            [value]="sellPoint.ID">
                    {{ sellPoint.PVLib }}
                </kal-option>

            </kal-select>

        </kal-form-field>

    </div>

    <!-- affichage des caisses -->
    <div *ngIf="displayedDesksList | arrayNotEmpty">

        <kal-form-field [kalTheme]="theme">

            <kal-select formControlName="deskId"
                        label="Caisse"
                        tabindex="1">

                <kal-option *ngFor="let desk of displayedDesksList"
                            [value]="desk.Id">
                    {{ desk.Libelle }}
                </kal-option>

            </kal-select>

        </kal-form-field>

    </div>

    <!-- affichage des stocks -->
    <div *ngIf="displayedStocksList | arrayNotEmpty">

        <kal-form-field [kalTheme]="theme">

            <kal-select formControlName="stockId"
                        label="Stock"
                        tabindex="1">

                <kal-option *ngFor="let stock of displayedStocksList"
                            [value]="stock.Id">
                    {{ stock.Libelle }}
                </kal-option>

            </kal-select>

        </kal-form-field>

    </div>

</div>
